import React from 'react';
import Navbar from './Navbar'
import Select from 'react-select'
import axios from 'axios'
import Altersuccess from './altert_success'
import Alterfailure from './alter_failure';

class Poll extends React.Component {
    state = {
        err: false,
        success: false
    }

    componentDidMount() {
        this.setState({
            user_id: this.props.user_data._id,
            poll_id: this.props.selectPoll[0]._id,
            weight: this.props.user_data.weight
        })
    }

    componentWillUnmount() {
        this.props.clearState()
    }

    setErr = (msg) => {
        this.setState({
            err: msg
        })
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        setTimeout(() => {
            this.setState({
                err: false
            })
        }, 3500)
    }


    sendData = (e) => {
        console.log("sending data back to server")
        e.preventDefault()
        axios.post('/api/student/poll', this.state).then((res) => {
            this.setState({
                success: true
            })
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
            setTimeout(() => {
                this.props.authFalse()
            }, 5000)
        }).catch((err) => {
            this.setState({
                err: 'Something went wrong! Couldn\'t submit poll'
            })
            setTimeout(() => {
                this.setState({
                    err: false
                })
            }, 3500)
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        })
    }

    handleVote = (e, id) => {
        if (e === null) {
            this.setState({
                [id]: "null"
            })
        } else {
            this.setState({
                [id]: (e.value)
            })
        }
        console.log(e)
        console.log(id)
    }

    render() {
        if (this.props.selectPoll === '') {
            return (
                <h2>Loading poll data</h2>
            )
        } else {
            window.addEventListener('beforeunload', function (e) {
                e.preventDefault();
                e.returnValue = 'You might lose data on page reload!';
            });

            return (
                <>
                    <Navbar state={this.state} categories={this.props.selectPoll[0].categories} sendData={this.sendData} weight={this.props.user_data.weight} setErr={this.setErr} />

                    <div style={{ marginTop: "75px" }}>
                        {this.state.err ? <Alterfailure errmsg={this.state.err} /> : null}
                        {this.state.success ? <Altersuccess /> : null}
                    </div>

                    <div className="container auto pDiv" style={{ marginTop: "95px", marginBottom: '30px' }}>
                        {this.props.selectPoll[0].contestants.map((data, index) => (
                            <div className={(index + 1 === this.props.selectPoll[0].contestants.length) ? "d-3" : "d-3 cDiv"} style={{ width: "100%" }} >
                                {data.name === this.props.user_data.name ? null
                                    : <div className="card-body">
                                        <div className="row">
                                            <h5 className="m-auto text-center" >
                                                {data.name}
                                            </h5>
                                            <div className="col-sm-4" >
                                                <Select
                                                    options={
                                                        this.props.selectPoll[0].categories.map((category) => (
                                                            { value: category.name, label: category.name }
                                                        ))
                                                    }
                                                    onChange={e => this.handleVote(e, data._id)}
                                                    isClearable={true}
                                                    isSearchable={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </>
            );
        }
    }
}

export default Poll;